import React from 'react';
import type { SVGProps } from 'react';

const IconHamburger = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 27 20" {...props}>
    <path stroke="currentColor" strokeWidth="2" d="M0 1.992h27M0 9.992h18M0 18.992h23" />
  </svg>
);

export default IconHamburger;
